import React, { FC, ReactNode, createContext, useContext, useMemo } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { InitialProps } from '../../lib/types/initialProps';

interface BriefsLobbyPageProps extends InitialProps {
  children: ReactNode;
}

export const InitialPropsContext = createContext<InitialProps | null>(null);

export const InitialPropsProvider: FC<BriefsLobbyPageProps> = ({ children, ...initialProps }) => {
  const client = useMemo(() => new QueryClient(), []);

  return (
    <InitialPropsContext.Provider value={initialProps}>
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </InitialPropsContext.Provider>
  );
};

export const useInitialProps = () => {
  const context = useContext(InitialPropsContext);
  if (!context) {
    throw new Error('useInitialProps must be used within a InitialPropsProvider');
  }
  return context;
};
